import React from 'react';
import PropTypes from 'prop-types';
// import LinearProgress from '@material-ui/core/LinearProgress';
import { DotsProgress } from 'components';
import MaterialPaper from '@material-ui/core/Paper';

const defaultPadding = 15;

const Paper = ({
  children,
  className,
  indicator,
  loading,
  padding,
  noPadding,
}) => {
  if (noPadding) {
    return (
      <div>
        {!!indicator && loading && (
          // <LinearProgress style={{ width: '100%' }} />
          <DotsProgress />
        )}
        <div className={`${loading ? 'loading' : ''} loading-enabled`}>
          {children}
        </div>
      </div>
    );
  }
  return (
    <MaterialPaper
      className={className}
      style={{ padding }}
    >
      {!!indicator && loading && (
        // <LinearProgress style={{ width: '100%' }} />
        <DotsProgress />
      )}
      <div className={`${loading ? 'loading' : ''} loading-enabled`}>
        {children}
      </div>
    </MaterialPaper>
  );
};

Paper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  indicator: PropTypes.bool,
  loading: PropTypes.bool,
  noPadding: PropTypes.bool,
  padding: PropTypes.number,
};

Paper.defaultProps = {
  className: '',
  indicator: false,
  loading: false,
  noPadding: false,
  padding: defaultPadding,
};

export default Paper;
